import styled from 'styled-components'
import { HStack } from '../../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const RatingWrap = styled(HStack)`
  justify-content: flex-start;
  height: 16px;
`
